import { roundDecimalPlaces, distancePt, randomAdjustment } from './utils.js'


class ShapeRadialSeries {

    constructor(
        shape,
    ) {
        this.shape = shape
    }


    getOuterParams(args) {
        let outerParams = []
        let start, end
        let arcSize = args.arc
        let stepSize = args.step
        let changeRepeat = args.arcChangeRepeat[0]
        let changeArc = 1 + (1 * args.arcChange)
        let changeStep = 1 + (1 * args.stepChange)
        let prevStart = 0
        for (let i = 0; i < args.maxRadials; i++) {
            arcSize =  arcSize * changeArc
            stepSize = stepSize * changeStep
            start = roundDecimalPlaces(prevStart + stepSize * randomAdjustment(args.stepRange), 4)
            end = roundDecimalPlaces(start + arcSize * changeRepeat * randomAdjustment(args.stepRange), 4)
            if (args.isCentered) {
                let neuStart = start + Math.abs(stepSize - arcSize) / 2
                let neuEnd = roundDecimalPlaces(neuStart + arcSize, 4)
                outerParams.push(neuStart, neuEnd)
            } else {
                outerParams.push(start, end)
            }
            prevStart = start
            // This can apply to either group or sequential
            changeRepeat = args.arcChangeRepeat[(i + 1) % args.arcChangeRepeat.length]
        }
        return outerParams
    }


    getRadialPoints(args, outerParams) {
        let curvePoints = []
        let radii = []
        let distance = args.radius
        let changeSize = 1 + (1 * args.radiusChange)
        let changeRepeat
        for (let i = 0; i < outerParams.length - 1; i+=2) {
            changeRepeat = args.radiusChangeRepeat[(i / 2) % args.radiusChangeRepeat.length]
            distance = distance * changeSize
            radii.push(distance * changeRepeat * randomAdjustment(args.radiusRange))
            curvePoints.push(distancePt(this.shape, args.centerPt, outerParams.at(i), radii.at(-1)))
            curvePoints.push(distancePt(this.shape, args.centerPt, outerParams.at(i + 1), radii.at(-1)))
        }
        return [radii, curvePoints]
    }


    buildRadial(args, shape, points, params, radius) {
        let path = ``

        // Go to start
        path = `${path} M ${args.centerPt.x} ${args.centerPt.y} `

        // Go to start of outer arc
        path = `${path} L ${points[0].x} ${points[0].y} `

        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params, radius)} `

        // Line back to start
        path = `${path} L ${args.centerPt.x} ${args.centerPt.y} `
        return path
    }


    getRadialShapes(args, outerParams, outerPoints, radii) {
        let shapePaths = []
        for (let i = 0; i < outerPoints.length - 1; i+=2) {
            let points = outerPoints.slice(i, i + 2)
            let params = outerParams.slice(i, i + 2)
            let radius = radii.at(i / 2)
            shapePaths.push(this.buildRadial(args, this.shape, points, params, radius))
        }
        return shapePaths
    }


    getRadials(
        args
    ) {

        let outerParams = this.getOuterParams(args)
        let [radii, radialPoints] = this.getRadialPoints(args, outerParams)
        let radialShapes = this.getRadialShapes(args, outerParams, radialPoints, radii)
        return radialShapes
    }
}

export { ShapeRadialSeries }
